import {
  Button,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
} from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import API from "../../services/api-request";
import { ArrowLeftOutlined } from "@ant-design/icons";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import UserManualButton from "../../components/UserManualButton";

const { RangePicker } = DatePicker;

const Calculator = () => {
  const [result, setResult] = useState(0);
  const [fishData, setFishData] = useState([]);
  const [selectedFish, setSelectedFish] = useState(null);
  const [duration, setDuration] = useState(0);
  const [calculateForm] = Form.useForm();
  const navigate = useNavigate();

  const handleCalculate = () => {
    const weight = calculateForm.getFieldValue("weight");
    const dateRange = calculateForm.getFieldValue("date");
    let daysDiff = 0;

    if (dateRange) {
      daysDiff = (dateRange[1] - dateRange[0]) / (1000 * 60 * 60 * 24) + 1;
    }

    setDuration(daysDiff);
    calculateForm.setFieldValue("duration", daysDiff);

    if (!weight || !daysDiff || !dateRange) {
      setResult(0);
      return;
    }

    let res = 0;

    if (daysDiff <= 7) {
      res = selectedFish.first_week_fee * weight;
    } else {
      const priceFirstWeek = selectedFish.first_week_fee * weight;
      res = priceFirstWeek + selectedFish.daily_fee * weight * (daysDiff - 7);
    }

    setResult(res);
  };

  const getCostData = async () => {
    await API.Get("storage-cost/public")
      .then((res) => {
        const data = res?.data;

        setFishData(data);
      })
      .catch((err) => {
        message.error("Failed to fetch Tipe Produk!");
        console.log(err);
      });
  };

  // const disabledDate = (current) => {
  //   return current && current < moment().startOf("day");
  // };

  useEffect(() => {
    getCostData();
  }, []);

  useEffect(() => {
    handleCalculate();
  }, [selectedFish]);

  return (
    <Flex
      justify="center"
      align="center"
      style={{
        backgroundColor: "#e4eafb",
        minHeight: "100vh",
        maxHeight: "100%",
        paddingTop: "2rem",
        paddingBottom: "2rem",
      }}
    >
      <Row
        gutter={24}
        style={{
          backgroundColor: "white",
          borderRadius: "20px",
          padding: "1rem",
          maxWidth: "60svw",
        }}
      >
        <Col span={24}>
          <div style={{ display: "flex" }}>
            <Button
              onClick={() => navigate("/login")}
              color="default"
              variant="link"
              style={{
                fontSize: "clamp(12px, 1.5vw, 16px)",
                marginBottom: "20px",
              }}
              icon={<ArrowLeftOutlined />}
            >
              Kembali
            </Button>
            <div style={{ width: "fit-content", marginLeft: "auto" }}>
              <UserManualButton />
            </div>
          </div>
        </Col>

        <Col lg={12} sm={24}>
          <Flex vertical justify="center" align="center">
            <img
              src={"./logo.png"}
              alt="mrt"
              width={150}
              style={{ marginBottom: "1rem" }}
            />
            <strong
              style={{
                textAlign: "center",
                fontSize: "clamp(16px, 1.5vw, 24px)",
              }}
            >
              Calculator Estimasi Biaya Penyimpanan
            </strong>
          </Flex>
          <Divider />
          <Form layout="vertical" form={calculateForm}>
            <Row gutter={24}>
              <Col span={24}>
                <Form.Item
                  label="Tipe Produk"
                  name="fishType"
                  rules={[
                    {
                      required: true,
                      message: "Please select Tipe Produk!",
                    },
                  ]}
                >
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    placeholder="Pilih Tipe Produk"
                    style={{ width: "100%" }}
                    options={fishData.map((data) => ({
                      label: data.product_type.size,
                      value: data.product_type_id,
                    }))}
                    value={selectedFish?.id}
                    onChange={(value) => {
                      setSelectedFish(
                        fishData.find((item) => item.product_type_id === value)
                      );
                    }}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Berat"
                  name="weight"
                  rules={[
                    {
                      required: true,
                      message: "Please input Berat!",
                    },
                  ]}
                >
                  <InputNumber
                    suffix="Kg"
                    placeholder="Berat"
                    style={{ width: "100%" }}
                    controls={false}
                    decimalSeparator=","
                    formatter={(value) =>
                      value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                    }
                    max={100000}
                    parser={(value) => value.replace(/\./g, "")}
                    onChange={handleCalculate}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  label="Rentang Tanggal"
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: "Please input Rentang Tanggal!",
                    },
                  ]}
                >
                  <RangePicker
                    style={{ width: "100%" }}
                    // disabledDate={disabledDate}
                    onChange={handleCalculate}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item label="Durasi" name="duration">
                  <Input placeholder="Durasi" suffix="Hari" readOnly />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>

        <Col lg={12} sm={24}>
          <Col
            span={24}
            style={{
              color: "white",
              backgroundColor: "#225c9d",
              borderRadius: "20px",
              padding: "1rem",
              height: "100%",
            }}
          >
            <div style={{ padding: "1rem" }}>
              <div style={{ fontWeight: "bold" }}>
                <p style={{ margin: 0, fontSize: "clamp(16px, 1.5vw, 25px)" }}>
                  Estimasi Total Biaya Penyimpanan
                </p>
                <p style={{ margin: 0, fontSize: "clamp(18px, 1.5vw, 30px)" }}>
                  Rp
                  <CountUp end={+result} duration={2} />
                </p>
              </div>

              <p
                style={{
                  color: "#c6e8ff",
                  fontSize: "clamp(12px, 1.5vw, 14px)",
                }}
              >
                Estimasi biaya penyimpanan {duration} hari
              </p>
            </div>

            <div style={{ padding: "1rem" }}>
              <div
                style={{
                  fontSize: "clamp(14px, 1.5vw, 20px)",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <p style={{ margin: 0, fontWeight: "bold" }}>
                  Estimasi Biaya minggu pertama
                </p>
                <p style={{ margin: 0 }}>
                  Rp
                  <CountUp
                    end={
                      +selectedFish?.first_week_fee?.toLocaleString("id-ID") *
                        +calculateForm.getFieldValue("weight") ?? 0
                    }
                  />
                </p>
              </div>

              <p
                style={{
                  color: "#c6e8ff",
                  fontSize: "clamp(12px, 1.5vw, 14px)",
                }}
              >
                Estimasi 7 hari pertama
              </p>
            </div>

            <div style={{ padding: "1rem" }}>
              <div
                style={{
                  fontSize: "clamp(14px, 1.5vw, 20px)",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <p style={{ margin: 0, fontWeight: "bold" }}>
                  Estimasi Biaya setelah 7 hari
                </p>
                <p style={{ margin: 0 }}>
                  Rp
                  <CountUp
                    end={
                      duration > 7
                        ? result -
                          selectedFish?.first_week_fee?.toLocaleString(
                            "id-ID"
                          ) *
                            calculateForm.getFieldValue("weight")
                        : 0
                    }
                  />
                </p>
              </div>

              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p
                  style={{
                    color: "#c6e8ff",
                    fontSize: "clamp(12px, 1.5vw, 14px)",
                  }}
                >
                  Estimasi Biaya per hari
                </p>
                <p
                  style={{
                    color: "#c6e8ff",
                    fontSize: "clamp(12px, 1.5vw, 14px)",
                  }}
                >
                  Rp
                  <CountUp
                    end={
                      duration > 7
                        ? selectedFish?.daily_fee?.toLocaleString("id-ID") *
                          calculateForm.getFieldValue("weight")
                        : 0
                    }
                  />
                </p>
              </div>
            </div>
            <Flex justify="center" align="flex-end">
              <Link
                to={"/policy-public"}
                style={{
                  color: "#225c9c",
                  marginBottom: "-6rem",
                  backgroundColor: "white",
                  padding: "5px 20px 5px 20px",
                  borderRadius: "5px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                }}
              >
                Kebijakan & Peraturan
              </Link>
            </Flex>
          </Col>
        </Col>
      </Row>
    </Flex>
  );
};

export default Calculator;
